module.exports = __webpack_public_path__ + "static/img/tree-title-bag.5f1cdf2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/tree-title-bag.png
// module id = vYoH
// module chunks = 96